import '@CSS/reset.css';
import '@CSS/form-controls.css';
import '@CSS/modal.css';
import '@CSS/variables.css';
import '@CSS/telecapeche2.css';

import { configureRollbar } from '@SUPPORT/rollbar';
configureRollbar();

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import { BrowserRouter, Route } from 'react-router-dom';

import { store } from '@STORES/login';
import { LoginRoot } from '@COMPONENTS/login/Root';

import { LanguageLoader } from '@COMPONENTS/common/LanguageLoader';

import { adaptToPlatform } from '@SUPPORT/utils';
adaptToPlatform();

const root = document.getElementById('root');
ReactDOM.render(
    <Provider store={store}>
        <LanguageLoader namespace="login">
            <BrowserRouter>
                <Route component={LoginRoot} />
            </BrowserRouter>
        </LanguageLoader>
    </Provider>,
    root
);
